import {
  Alert,
  AlertTitle,
  Button,
  Drawer,
  DrawerBody,
  IconButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Spacer,
  useToast,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { get } from "lodash";
import * as Yup from "yup";
import { FormField } from "../form/formField/FormField";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { MdModeEditOutline } from "react-icons/md";
import { ITutorial } from "../../types/tutorial";
import { useTutorialsMaster } from "../../store/tutorial/reducer";
import {
  REQUEST_CREATE_MASTER_TUTORIAL,
  REQUEST_UPDATE_MASTER_TUTORIAL,
} from "../../store/tutorial/tutorialActionTypes";
import { FormFieldEditor } from "../form/formField/FormFieldEditor";
interface Props {
  tutorial?: ITutorial;
  isOpen: any;
  onClose: any;
}

// const FILE_SIZE = 3 * 1024 * 1024;

// const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];

const addSchema = Yup.object({
  title: Yup.string().required("Required"),
  embeddedLink: Yup.string().optional(),
  description: Yup.string().optional(),
});

const TutorialMasterEditDrawer: React.FC<Props> = ({
  tutorial,
  isOpen,
  onClose,
}) => {
  const { masterTutorials, busy, message } = useTutorialsMaster();

  const dispatch = useDispatch();

  const initialValue = useMemo(() => {
    if (tutorial) {
      return {
        title: tutorial.title,
        embeddedLink: tutorial.embeddedLink,
        description: tutorial.description,
      };
    }
    return {
      title: "",
      embeddedLink: "",
      description: "",
    };
  }, [tutorial]);

  const onSubmit = (values: Record<string, any>) => {
    let payload: Record<string, any> = {
      title: values.title,
      embeddedLink: values.embeddedLink,
      description: values.description,
    };

    if (tutorial) {
      const data = { payload, _id: tutorial._id };
      dispatch({ type: REQUEST_UPDATE_MASTER_TUTORIAL, data });
    } else {
      dispatch({ type: REQUEST_CREATE_MASTER_TUTORIAL, payload });
    }
  };

  const toast = useToast();
  const tutorials = useMemo(() => {
    return masterTutorials;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tutorial) {
      const linkFromStore = masterTutorials.find(
        (ml: any) => ml._id === tutorial._id
      );
      if (linkFromStore !== tutorial) {
        toast({
          title: "Success.",
          description: "Link is updated.",
          status: "success",
          isClosable: true,
          position: "top-right",
        });
        onClose();
      }
    } else if (tutorials.length !== masterTutorials.length) {
      toast({
        title: "Success.",
        description: "Link is created.",
        status: "success",
        isClosable: true,
        position: "top-right",
      });
      onClose();
    }
  }, [masterTutorials, tutorials, onClose, tutorial, toast]);

  const [isDisabled, setDisabled] = useState(!!(tutorial && tutorial._id));

  return (
    <Formik
      initialValues={initialValue}
      validationSchema={addSchema}
      onSubmit={onSubmit}
    >
      {({ errors, touched, submitForm, setFieldValue }) => (
        <Form>
          <Drawer
            isOpen={isOpen}
            placement="right"
            size={"md"}
            onClose={onClose}
            closeOnOverlayClick={busy}
          >
            <DrawerOverlay />
            <DrawerContent>
              <DrawerHeader backgroundColor={"gray.100"} alignItems={"stretch"}>
                <Flex>
                  {get(tutorial, "title") || "Add tutorial"}
                  <Spacer></Spacer>
                  {tutorial && tutorial._id && (
                    <IconButton
                      aria-label="update link"
                      key={"updateLinkButton"}
                      alignSelf={"end"}
                      onClick={() => {
                        setDisabled(!isDisabled);
                      }}
                      icon={<MdModeEditOutline />}
                    ></IconButton>
                  )}
                </Flex>

                {message && (
                  <Alert status="error">
                    <AlertTitle>{message}</AlertTitle>
                  </Alert>
                )}
              </DrawerHeader>
              <DrawerBody>
                <FormField
                  required={true}
                  disabled={isDisabled}
                  name="Name : "
                  fieldName="title"
                  type="text"
                  error={touched.title ? (errors.title as string) : undefined}
                />

                <FormField
                  disabled={isDisabled}
                  required={false}
                  name="Embedded link : "
                  fieldName="embeddedLink"
                  type="text"
                  error={
                    errors.embeddedLink
                      ? (errors.embeddedLink as string)
                      : undefined
                  }
                />
                {/* <FormFieldTextArea
                  disabled={isDisabled}
                  required={false}
                  name="Description : "
                  fieldName="description"
                  type="text"
                  error={
                    errors.description
                      ? (errors.description as string)
                      : undefined
                  }
                /> */}
                <FormFieldEditor
                  disabled={isDisabled}
                  required={true}
                  name="Description : "
                  fieldName="description"
                  type="textarea"
                  error={
                    touched.description
                      ? (errors.description as string)
                      : undefined
                  }
                />
              </DrawerBody>
              <DrawerFooter backgroundColor={"gray.100"}>
                <Button
                  variant="outline"
                  mr={3}
                  onClick={onClose}
                  disabled={busy}
                >
                  Close
                </Button>
                <Button
                  colorScheme="blue"
                  onClick={submitForm}
                  disabled={busy || isDisabled}
                >
                  {tutorial && tutorial._id ? "Update" : "Save"}
                </Button>
              </DrawerFooter>
            </DrawerContent>
          </Drawer>
        </Form>
      )}
    </Formik>
  );
};
export default TutorialMasterEditDrawer;
